










































import { Vue, Component, Watch, Prop } from "vue-property-decorator";

import SearchInput from "@share/common/search-input/SearchInput.vue";
import { Debounce } from "vue-debounce-decorator";
import { userSearch } from "@share/meeting-form/helpers/UserSearch";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { UserRepository } from "@api/repositories/UserRepository";
import { UserProfile } from "@api/models/UserProfile";
import { groupFilter } from "@api/helpers/groupFilter";

import { isBottom as isBottomFn} from "@common/isBottom";
import {EventBus} from "@common/EventBus";

import SearchUser from "@share/meeting-form/components/SearchUser.vue"
import Participant from "@share/meeting-form/components/Participant.vue";

@Component({ components: { SearchInput, SearchUser, Participant }})

export default class PeopleSelect extends Vue {

    @Prop() eventId: string | undefined;
    @Prop({ default: "" }) errors: string;
    @Prop() value: UserProfile[];
    @Prop() title: string | undefined;
    @Prop() role: ["speaker" | "participant"] | "speaker" | "participant" | undefined;
    @Prop({ default: true }) excludeCurrentUser: boolean;
    @Prop({ default: true }) needTitle: boolean;
    @Prop({ default: true }) useGroupFilter: boolean;
    @Prop({ default: 20 }) participantsLimit: number;

    get selectedList() {
        return this.value.filter((userProfile) => this.excludeCurrentUser ? userProfile.userId != this.userId : true)
    }

    get isAddParticipantAvailable() {
        return this.selectedList.length < this.participantsLimit;
    }

    searchStr = '';

    areUsersLoading = false;
    usersAmount = 0;

    foundUsers: UserProfile[] = [];

    searchPage = 1;
    usersPerPage = 20;

    userRepository: UserRepository;

    clear(event: MouseEvent) {
        event.stopPropagation();
        this.searchStr = ''
    }

    mounted() {
        this.attachUserScrollHandler();

        this.userRepository = this.$repositories.get(RepositoryFabric.USER);

        this.init();
    }

    async init() {
        await this.doSearch();
    }

    destroyed() {
        this.removeUserScrollHandler();
    }

    attachUserScrollHandler() {
        this.$refs['userList'] && (this.$refs['userList'] as HTMLElement).addEventListener('scroll', this.userScrollHandler)
    }

    removeUserScrollHandler() {
        this.$refs['userList'] && (this.$refs['userList'] as HTMLElement).removeEventListener('scroll', this.userScrollHandler);
    }

    @Watch('searchStr')
    @Debounce(500)
    async searchInput() {
        this.searchPage = 1;
        await this.doSearch();
    }

    async doSearch() {
        this.areUsersLoading = true;
        const skip = this.usersPerPage * (this.searchPage - 1);

        try {
            const result = await userSearch(this.usersPerPage, skip, this.userRepository, this.searchStr, this.excludedUserIds, this.groupFilter, this.$store.getters['ignoredUserGroupIds'], this.eventId, this.role);

            this.usersAmount = result.count;
            if (this.searchPage == 1) {
                this.foundUsers = result.profiles;
            }
            else {
                this.foundUsers = [...this.foundUsers, ...result.profiles];
            }
        }
        catch(e) {
            this.$store.dispatch('reportError', e);
        }
        finally {
            this.areUsersLoading = false;
        }
    }

    removeUserFromList(id: string) {
        this.foundUsers = this.foundUsers.filter((user) => user.id !== id);
    }

    choose(user: UserProfile) {
        const index = this.value.findIndex(item => item.userId == user.userId);

        const newValue = [...this.value];

        // ADD:
        if (index < 0 && this.isAddParticipantAvailable) {

            newValue.push(user);
            this.$emit('input', newValue);
            this.$emit('clearErrors')
        }

        // REMOVE:
        if (index >= 0) {
            this.deleteParticipant(newValue, user);
        }
    }

    deleteParticipant(list: UserProfile[], participant: UserProfile) {
        const index = list.findIndex(item => item.userId == participant.userId);
        if (index > -1) {
            list.splice(index, 1)
            this.$emit('input', list)
        }
    }

    @Debounce(500)
    userScrollHandler() {
        if (!this.areUsersLoading && this.usersAmount > this.foundUsers.length) {
            const isBottom = isBottomFn(this.$refs['userList'] as HTMLElement)

            if (isBottom) {
                this.searchPage++;
                this.doSearch();
            }
        }
    }

    showProfile(userId: number | UserProfile) {
        userId = typeof userId == 'number' ? userId : userId.userId as number;
        EventBus.$emit('showChatByUserId', userId);
    }

    get isChatAllowed() {
        return this.$store.getters["events/isChatAllowed"]
    }

    // если параметр allowMeetingWithSpeakers=false в параметрах мероприятия, то нужно удалить всех спикеров
    get excludedUserIds() {
        if(this.excludeCurrentUser) {
            if (!this.$store.getters['events/allowMeetingWithSpeakers']) {
                return this.$store.getters['events/selectedEventSpeakers'].concat(this.userId);
            }
            return [this.userId];
        }
        else {
            return [];
        }
    }

    get groupFilter() {
        const params = this.$store.getters['events/selectedEventViewParam']('participants', null);
        const groupIds = params?.groupIds || this.$store.state.session.profile?.groupIds || [];

        return this.useGroupFilter ? groupFilter(groupIds) : [];
    }

    get userId() {
        return this.$store.state.session.userId;
    }
}

